export default Object.freeze({
  CustomPopup: 1,
  RequestGeolocation: 2,
  TakeASelfie: 3,
  ChallengePerformance: 4,
  ChallengeCompleteConfirmation: 5,
});
